export const CHECKOUT_URL = "https://reflexbp-en.impultienda.ar/checkout/";

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/qftpRGQPhz8SKbmGx8ntgd/RFLEXBLUEPRINT-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/5DFPubPgLbdiETJcctCuzG/ELLY_DELGADO_-_REFLEXOLOGY.png",
};

export const offerStack = [
  { label: "Reflexology Session Blueprint™ — 6 Premium Volumes", value: "$97" },
  { label: "Bonus #1 · 50 Reflexology Practice Cards™", value: "$37" },
  { label: "Bonus #2 · The 15-Minute Practice Protocol™", value: "$37" },
  { label: "Bonus #3 · The Beginner Organization Mistakes Guide™", value: "$27" },
  { label: "Bonus #4 · The 21-Day Reflexology Practice Planner™", value: "$29" },
  { label: "Bonus #5 · 30 Reflexology Practice Checklists™", value: "$17" },
];

export const scarcity = {
  spotsLeft: 7,
  percentClaimed: 93,
};
